export default {
  api: 'https://api.mcgmedia.net/',
  //api: 'http://localhost:3040',
  googleApi: 'AIzaSyBWbO6Ap_bb_IzBOqH5qeuvp3vne6fQ-4I',
  googleMapLink: 'https://www.google.com/maps/embed/v1/place?q='
}